import React, { Component } from "react";
import {Helmet} from 'react-helmet'

class PageHelmet extends Component{
    render(){
        return(
            <React.Fragment>
                <Helmet>
                    <title>{this.props.pageTitle} || Rutherford & Wheeler</title>
                    <meta name="description" content="Rutherford & Wheeler - Museum Technical Services Since 1989" />
                </Helmet>
            </React.Fragment>
        )
    }
}


export default PageHelmet;
